import { StacksmashingSPIFlasher } from "./adapters/stacksmashing_spiflasher"
import { CH341a } from "./adapters/CH341a"
import { FT232H } from "./adapters/FT232H"

const USB_ADAPTERS = [
    new StacksmashingSPIFlasher(),
    new CH341a(),
    new FT232H()
]

export {USB_ADAPTERS}
